// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  TelemetryStreamType,
  AlertCondition,
  AlertSeverity,
  AlertState,
  AlertConditionV2,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  projectId: __t.u32().name("project_id"),
  twinId: __t.option(__t.string()).name("twin_id"),
  streamName: __t.string().name("stream_name"),
  get streamType() {
    return TelemetryStreamType.name("stream_type");
  },
  get condition() {
    return AlertCondition;
  },
  get severity() {
    return AlertSeverity;
  },
  name: __t.string(),
  description: __t.string(),
  enabled: __t.bool(),
  get lastState() {
    return AlertState.name("last_state");
  },
  lastEvaluatedAt: __t.option(__t.timestamp()).name("last_evaluated_at"),
  lastFiredAt: __t.option(__t.timestamp()).name("last_fired_at"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  lastValueRepr: __t.option(__t.string()).name("last_value_repr"),
  lastChangeAt: __t.option(__t.timestamp()).name("last_change_at"),
  get conditionV2() {
    return __t.option(AlertConditionV2).name("condition_v_2");
  },
});
